<div class="promo-bar" *ngIf="isShowing">
    <span>
        1120-H tax returns are due on 4/15. Use our contracted CPA to file Federal and State for $399. <a href='https://forms.gle/HygqxE43Kh47K4TSA'>Get Started.</a>
    </span>
    <img (click)="close()" class="mat-close" src="/assets/images/payhoa/other/icon_close.svg" alt="close">
</div>
